module.exports = __webpack_public_path__ + "img/1.1de05b29.png";